"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.timezonesLongAbbreviations = exports.timezoneMapping = void 0;
const timezoneMapping = Object.freeze({
    // sorted by most likely to use a SaaS (chatGPT)
    // with some changes form me
    'Coordinated Universal Time': 'UTC',
    'Pacific Time': 'PT',
    'Eastern Time': 'ET',
    'Central Time': 'CT',
    'Mountain Time': 'MT',
    'Eastern Standard Time': 'EST',
    'Pacific Standard Time': 'PST',
    'Pacific Daylight Time': 'PDT',
    'Mountain Standard Time': 'MST',
    'Mountain Daylight Time': 'MDT',
    'Central Daylight Time': 'CDT',
    'Central Standard Time': 'CST',
    'Central European Time': 'CET',
    'Central European Standard Time': 'CET',
    'Central European Summer Time': 'CEST',
    'Middle European Time': 'MET',
    'Middle European Summer Time': 'MEST',
    'British Summer Time': 'BST',
    'Greenwich Mean Time': 'GMT',
    'Western European Time': 'WET',
    'Western European Summer Time': 'WEST',
    'Eastern European Time': 'EET',
    'Eastern European Standard Time': 'EET',
    'Eastern European Summer Time': 'EEST',
    'Israel Standard Time': 'IST',
    'Israel Daylight Time': 'IDT',
    'Japan Standard Time': 'JST',
    'Korea Standard Time': 'KST',
    'Hong Kong Time': 'HKT',
    'Singapore Time': 'SGT',
    'Australian Eastern Time': 'AET',
    'Australian Eastern Daylight Saving Time': 'AEDT',
    'Australian Eastern Daylight Time': 'AEDT',
    'Australian Eastern Standard Time': 'AEST',
    'Pohnpei Standard Time': 'PONT',
    'Australian Central Daylight Saving Time': 'ACDT',
    'Australian Central Standard Time': 'ACST',
    'Australian Western Standard Time': 'AWST',
    'Western Standard Time': 'WST',
    'Australian Central Western Standard Time': 'ACWST',
    'Central Western Standard Time': 'CWST',
    'West Greenland Summer Time': 'WGST',
    'West Greenland Time': 'WGT',
    'Moscow Time': 'MSK',
    'Novosibirsk Time': 'NOVT',
    'Irkutsk Time': 'IRKT',
    'Vladivostok Time': 'VLAT',
    'Volgograd Time': 'VOLT',
    'Vostok Station Time': 'VOST',
    'Yakutsk Time': 'YAKT',
    'Yekaterinburg Time': 'YEKT',
    'India Standard Time': 'IST',
    'Indian Ocean Time': 'IOT',
    'China Standard Time': 'CST',
    'Taiwan Standard Time': 'TST',
    'Philippine Time': 'PHT',
    'Philippine Standard Time': 'PHST',
    'New Zealand Daylight Time': 'NZDT',
    'New Zealand Standard Time': 'NZST',
    'New Zealand Daylight Saving Time': 'NZDST',
    'Atlantic Standard Time': 'AST',
    'Atlantic Daylight Time': 'ADT',
    'Eastern Greenland Summer Time': 'EGST',
    'Eastern Greenland Time': 'EGT',
    'Argentina Time': 'ART',
    'Brasília Time': 'BRT',
    'Brasília Summer Time': 'BRST',
    'Amazon Summer Time': 'AMST',
    'Uruguay Standard Time': 'UYT',
    'Uruguay Summer Time': 'UYST',
    'Turkey Time': 'TRT',
    'Gulf Standard Time': 'GST',
    'Iran Standard Time': 'IRST',
    'Iran Daylight Time': 'IRDT',
    'Pakistan Standard Time': 'PKT',
    'Indochina Time': 'ICT',
    'Malaysia Time': 'MYT',
    'Central Indonesia Time': 'WITA',
    'Eastern Indonesian Time': 'WIT',
    'Western Indonesian Time': 'WIB',
    'Thailand Standard Time': 'THA',
    'Bangladesh Standard Time': 'BST',
    'Further-eastern European Time': 'FET',
    'South African Standard Time': 'SAST',
    'West Africa Time': 'WAT',
    'West Africa Summer Time': 'WAST',
    'West Africa Standard Time': 'WAT',
    'Azores Standard Time': 'AZOT',
    'Azores Summer Time': 'AZOST',
    'Chile Standard Time': 'CLT',
    'Chile Summer Time': 'CLST',
    'Colombia Time': 'COT',
    'Colombia Summer Time': 'COST',
    'Peru Time': 'PET',
    'Bolivia Time': 'BOT',
    'Paraguay Time': 'PYT',
    'Paraguay Summer Time': 'PYST',
    'Venezuelan Standard Time': 'VET',
    'Alaska Standard Time': 'AKST',
    'Alaska Daylight Time': 'AKDT',
    'Hawaii–Aleutian Standard Time': 'HST',
    'Hawaii–Aleutian Daylight Time': 'HDT',
    'Fiji Time': 'FJT',
    'French Guiana Time': 'GFT',
    'Ecuador Time': 'ECT',
    'Galápagos Time': 'GALT',
    'Guyana Time': 'GYT',
    'Newfoundland Time': 'NT',
    'Newfoundland Standard Time': 'NST',
    'Newfoundland Daylight Time': 'NDT',
    'Saint Pierre and Miquelon Standard Time': 'PMST',
    'Saint Pierre and Miquelon Daylight Time': 'PMDT',
    'Central Africa Time': 'CAT',
    'Mauritius Time': 'MUT',
    'Maldives Time': 'MVT',
    'Nepal Time': 'NPT',
    'Bhutan Time': 'BTT',
    'Myanmar Standard Time': 'MMT',
    'Sri Lanka Standard Time': 'SLST',
    'Seychelles Time': 'SCT',
    'Brunei Time': 'BNT',
    'Papua New Guinea Time': 'PGT',
    'Cuba Standard Time': 'CST',
    'Cuba Daylight Time': 'CDT',
    'Chatham Standard Time': 'CHAST',
    'Chatham Daylight Time': 'CHADT',
    'New Caledonia Time': 'NCT',
    'Norfolk Island Time': 'NFT',
    'Samoa Standard Time': 'SST',
    'Samoa Daylight Time': 'SDT',
    'Solomon Islands Time': 'SBT',
    'Tonga Time': 'TOT',
    'Tahiti Time': 'TAHT',
    'Niue Time': 'NUT',
    'Wake Island Time': 'WAKT',
    'Phoenix Island Time': 'PHOT',
    'Tokelau Time': 'TKT',
    'Line Islands Time': 'LINT',
    'Marshall Islands Time': 'MHT',
    'Palau Time': 'PWT',
    'Tuvalu Time': 'TVT',
    'Christmas Island Time': 'CXT',
    'Cocos Islands Time': 'CCT',
    'Clipperton Island Standard Time': 'CIST',
    'Baker Island Time': 'BIT',
    'Heard and McDonald Islands Time': 'HMT',
    'French Southern and Antarctic Time': 'TFT',
    'Macquarie Island Station Time': 'MIST',
    'Mawson Station Time': 'MAWT',
    // from this point on, it's alphabetical order with the left ones
    'ASEAN Common Time': 'ACT',
    'Afghanistan Time': 'AFT',
    'Alma-Ata Time': 'ALMT',
    'Anadyr Time': 'ANAT',
    'Aqtobe Time': 'AQTT',
    'Armenia Time': 'AMT',
    'Azerbaijan Time': 'AZT',
    'British Indian Ocean Time': 'BIOT',
    'Cape Verde Time': 'CVT',
    'Chamorro Standard Time': 'CHST',
    'Choibalsan Standard Time': 'CHOT',
    'Choibalsan Summer Time': 'CHOST',
    'Chuuk Time': 'CHUT',
    'Cook Island Time': 'CKT',
    'Davis Time': 'DAVT',
    'East Africa Time': 'EAT',
    'Easter Island Standard Time': 'EAST',
    'Easter Island Summer Time': 'EASST',
    'Eastern Daylight Time': 'EDT',
    'Falkland Islands Summer Time': 'FKST',
    'Falkland Islands Time': 'FKT',
    'Fernando de Noronha Time': 'FNT',
    'Gambier Island Time': 'GIT',
    'Gambier Islands Time': 'GAMT',
    'Georgia Standard Time': 'GET',
    'Gilbert Island Time': 'GILT',
    'Hovd Summer Time': 'HOVST',
    'Hovd Time': 'HOVT',
    'International Date Line West time zone': 'IDLW',
    'Kaliningrad Time': 'KALT',
    'Kamchatka Time': 'PETT',
    'Kosrae Time': 'KOST',
    'Krasnoyarsk Time': 'KRAT',
    'Kyrgyzstan Time': 'KGT',
    'Lord Howe Summer Time': 'LHST',
    'Magadan Time': 'MAGT',
    'Marquesas Islands Time': 'MIT',
    'Omsk Time': 'OMST',
    'Oral Time': 'ORAT',
    'Rothera Research Station Time': 'ROTT',
    'Réunion Time': 'RET',
    'Sakhalin Island Time': 'SAKT',
    'Samara Time': 'SAMT',
    'Showa Station Time': 'SYOT',
    'Srednekolymsk Time': 'SRET',
    'Suriname Time': 'SRT',
    'Tajikistan Time': 'TJT',
    'Timor Leste Time': 'TLT',
    'Turkmenistan Time': 'TMT',
    'Ulaanbaatar Standard Time': 'ULAT',
    'Ulaanbaatar Summer Time': 'ULAST',
    'Uzbekistan Time': 'UZT',
    'Vanuatu Time': 'VUT',
});
exports.timezoneMapping = timezoneMapping;
const timezonesLongAbbreviations = Object.keys(timezoneMapping);
exports.timezonesLongAbbreviations = timezonesLongAbbreviations;
//# sourceMappingURL=constants.js.map